import { takeLatest, call, put, select } from 'redux-saga/effects';
import axios from 'axios';


import { API_LINK, STORAGE_LINK } from '../../constants';
import moment from 'moment';
import { turnitinDoSubmissionFailure, turnitinDoSubmissionRequest, turnitinDoSubmissionSuccess, turnitinGenerateRequest } from '../reducers/turnitin';

const API = `${API_LINK}api`;



function* turnitinUploadFunctionAxios() {
  const state = yield select(fullState => fullState);
  const { statementid,
    request_id,
    selectedContent,
    doc_url } = state.turnitinReducer;
  const {
    user,
    token,
  } = state.loginReducer;

  const { assessmentContent } = state.userProgramsFullReducer;
  var data = JSON.stringify({
    "owner": user.userId,
    "title": assessmentContent.name,
    "owner_default_permission_set": "LEARNER",
    "metadata": {
      "owners": [
        {
          "id": user.userId,
          "given_name": user.firstName,
          "family_name": user.lastName,
          "email": user.email
        }
      ],
      "original_submitted_time": moment().format('YYYY-MM-DDTHH:mm:ss').toString()+'Z',
      "custom": "{\"Type\":\"Free Text\", \"request_id\":\""+request_id+"\", \"user_id\":\""+user.userId+"\"}"
    }
  });
  const response = yield call(() =>
    axios({
      method: 'put',
      url: API+'/assessor/tii_submission',
      headers: {
        'Access-Control-Allow-Origin': '*',
        'Content-Type': 'application/json',
        'X-Uploaaded-With': 'XMLHttpUploaad',
        Authorization: `Bearer ${token}`,
      },
      credentials: 'same-origin',
      data: {
        tii_data: data,
        statementid: statementid,
        url: STORAGE_LINK+doc_url
      },
    }),
  );

  return response;
}

function* workerTurnitinUploadSaga() {
  try {
    const response = yield call(turnitinUploadFunctionAxios);
    const responseFromTurnitinUpload = response.data;
    if (response.status === 200) {
      yield put(turnitinDoSubmissionSuccess(responseFromTurnitinUpload));
      //yield put(turnitinGenerateRequest());
    }
    if (response.status === 201) {
      yield put(turnitinDoSubmissionFailure(responseFromTurnitinUpload.message));
    }
  } catch (error) {
    yield put(turnitinDoSubmissionFailure(error.message));
  }
}

export function* watcherTurnitinUploadSaga() {
 
  yield takeLatest(turnitinDoSubmissionRequest().type, workerTurnitinUploadSaga);
}
